/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
    .rowProgress {
        font-size: 13px;
        padding: 4px;
    }

    .current_state {
        background-color: ${$.secondaryMain};
    }

    .complete_state {
        background-color: ${$.secondaryMain};

        &.is-last-state {
            background-color: ${$.successMain};
        }
    }

    .next_state {
        background-color: ${$.gray100};
    }
`;
